import { validateProperty } from './validateProperty';
export const validateApp = app => {
  const isValidApp = typeof app === 'string' && app.length > 0;
  return validateProperty(isValidApp, `expected app to be a non-empty string but got ${app}`, 'app');
};